//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { access } from "fs";
export default {
  name: "",
  components: {},
  data() {
    return {
      activeIndex: null,
      isPickerShow: false,
      currentDate: new Date()
      // 示例数据：
      // formConfig: {fontSize:'14px', list:[
      //   { type: 'input', title: '订单号', placeholder: '请输入订单号', no_arrow: true },
      //   { type: 'date', title: '制单时间', value:'', placeholder: '年/月/日', no_arrow: true },
      // ]},
    };
  },
  props: ["config"],
  computed: {
    host(){
      return this.$api.host
    }
  },
  methods: {
    showDatePicker(index) {
      this.isPickerShow = true;
      this.activeIndex = index;
    },
    onConfirmDatePicker(value) {
      this.config.list[this.activeIndex].value =
        value.getFullYear() + "/" + value.getMonth() + "/" + value.getDate();
      this.isPickerShow = false;
    },
    onClickItem(item) {
      if (item.action) {
        item.action();
      }
    },
    get_input_back() {},
    handleClick(index) {
      this.isPickerShow = true;
      this.activeIndex = index;
    },
    take_tel() {},
    onClickPhoneBtn(btn) {
      if (btn.action) {
        btn.action();
      }
    },
    radioChange(res, item) {
      this.$emit("radioCb", {
        name: item.title,
        id: item.value
      });
    },
    clearUploadImg(subItem) {
      this.$refs.fileInput.value = null;
      subItem.value = "";
    },
    file_change(e, Item) {
      var imgFile = e.target.files[0];
      if (imgFile) {
        this.$msg.loading("上传中");
        var fr = new FileReader();
        fr.readAsDataURL(imgFile);
        fr.onload = () => {
          var base_url = fr.result
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
              .replace("data:image/jpeg;base64,", ""),
            formData = new FormData();
          formData.append("url", base_url);
          console.log(base_url,formData)
          this.$http
            .post(this.$api.upload_img, formData, {
              headers: { "Content-Type": "multipart/form-data" }
            })
            .then(res => {
              this.$msg.hideLoading();
              if (res.data.state == 1) {
                Item.value = res.data.data.src;
              } else {
                this.$msg.alert(res.data.msg);
              }
            })
            .catch(err => {
              this.$msg.hideLoading();
            });
        };
      }
    },
  }
};
